import { action, makeAutoObservable } from 'mobx';
import { setPathValue, getPathValue } from 'pathval';
import * as slideVerificationApi from 'src/api/slideVerification';
// import modalStore from 'stores/common/modalComponent';

const BUTTON_WIDTH = 50;
/** 验证图片自然尺寸 */
const PICTURE_NATURAL_SIZE = { width: 500, height: 250 };

const width = 330;
const slideBarWidth = width - BUTTON_WIDTH - 2;
const imgScale = width / PICTURE_NATURAL_SIZE.width;

class SlideVerificationStore {
  componentState = {
    /** 验证器图片区域宽度 */
    width,
    /** 按钮滑动区域宽度 */
    slideBarWidth,
    /** 图片加载到验证器的缩放比例 */
    imgScale,
    /** 验证图片自然尺寸 */
    pictureSize: {
      width: PICTURE_NATURAL_SIZE.width * imgScale,
      height: PICTURE_NATURAL_SIZE.height * imgScale
    },
    /** 验证结果标记 0为默认状态，1为成功状态，2为失败状态 */
    verifyResultFlag: 0,
    /** 是否开始滑动按钮 */
    isSlideButton: false,
    /** 按钮滑动开始X的值 */
    slideButtonStartx: 0,
    /** 按钮向右滑动距离 */
    slideButtonx: 0,
  };

  verificatePicture = {
    isLoading: false,
    data: {}
  };

  constructor() {
    makeAutoObservable(this);
  }

  setValue = (key, value) => {
    setPathValue(this, key, value);
  }

  // handleShowSlideVerification(data) {
  //   modalStore.open({
  //     title: '请完成安全验证',
  //     width: 350,
  //     paddingNone: true,
  //     data,
  //     footer: false,
  //     loader: () => import('components/common/SlideVerification'),
  //   });
  // }

  // handleColseSlideVerification() {
  //   modalStore.resetStore();
  // }

  getSlideVerificatePicture = () => {
    this.verificatePicture.isLoading = true;
    slideVerificationApi.getSlideVerificatePicture()
      .then(action('getSlideVerificatePicture', (resp) => {
        this.verificatePicture.isLoading = false;
        this.verificatePicture.data = resp;
      }))
      .catch(action('getSlideVerificatePicture error', (err) => {
        this.verificatePicture.isLoading = false;
        this.verificatePicture.data = {};
        console.log(err);
      }));
  }

  // handleCloseSlideVerification() {
  //   modalStore.close();
  // }

  resetComponentState = () => {
    this.componentState = {
      /** 验证器图片区域宽度 */
      width,
      /** 按钮滑动区域宽度 */
      slideBarWidth,
      /** 图片加载到验证器的缩放比例 */
      imgScale,
      /** 验证图片自然尺寸 */
      pictureSize: {
        width: PICTURE_NATURAL_SIZE.width * imgScale,
        height: PICTURE_NATURAL_SIZE.height * imgScale
      },
      /** 验证结果标记 0为默认状态，1为成功状态，2为失败状态 */
      verifyResultFlag: 0,
      /** 是否开始滑动按钮 */
      isSlideButton: false,
      /** 按钮滑动开始X的值 */
      slideButtonStartx: 0,
      /** 按钮向右滑动距离 */
      slideButtonx: 0,
    };
  }
}

export const SlideVerificationStoreClass = SlideVerificationStore;
export default new SlideVerificationStore();
